// Responsive breakpoints.
const breakpoints = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1550
};

// Header & navigation.
(function () {
    const header = document.getElementById("site-header");
    const navigation = document.getElementById("site-navigation");
    const hamburger = document.getElementById("site-hamburger");
    const menu = document.getElementById("site-menu");


    (function () {
        // Define sticky header scroll breakpoint.
        let sticky_header_scroll_breakpoint = header.offsetTop;

        if (document.body.classList.contains("admin-bar")) {
            if (screen.width > 782) {
                sticky_header_scroll_breakpoint -= 32;
            } else if (screen.width > 600) {
                sticky_header_scroll_breakpoint -= 46;
            }
        }

        /**
         * Refreshes classes of sticky header.
         */
        function refresh_sticky_header_classes() {
            if (window.scrollY > sticky_header_scroll_breakpoint) {
                header.classList.add("sticky");
            } else {
                header.classList.remove("sticky");
            }
        }

        window.addEventListener("scroll", refresh_sticky_header_classes);
        setTimeout(refresh_sticky_header_classes, 50);


        /**
         * Toggles header navigation.
         */
        function on_hamburger_click() {
            if (navigation.classList.contains("active")) {
                if (window.scrollY <= sticky_header_scroll_breakpoint) {
                    header.classList.remove("filled");
                }

                navigation.classList.remove("active");
                hamburger.classList.remove("active");
                hamburger.ariaExpanded = "false";

                hamburger.focus();
            } else {
                header.classList.add("filled");
                navigation.classList.add("active");
                hamburger.classList.add("active");
                hamburger.ariaExpanded = "true";

                const navigation_first_link = navigation.querySelector("#site-menu li:first-child a");

                if (navigation_first_link) {
                    navigation_first_link.focus();
                }
            }
        }

        hamburger.addEventListener("click", on_hamburger_click);
    })();


    (function () {
        /**
         * Called when menu item parent has been clicked.
         *
         * @param {Event} event
         */
        function on_menu_item_parent_click(event) {
            if (screen.width >= breakpoints.xl) {
                return;
            }

            event.stopPropagation();

            const parent = event.currentTarget;
            const is_active = parent.classList.contains("active");
            const submenu = parent.querySelector(":scope > ul, :scope > .megamenu");

            if (is_active) {
                parent.classList.remove("active");

                if (submenu) {
                    submenu.style.height = submenu.scrollHeight + "px";
                    setTimeout(() => submenu.style.height = "0", 0);
                }
            } else {
                parent.classList.add("active");

                if (submenu) {
                    submenu.style.height = "auto";
                    const submenu_height = submenu.scrollHeight;
                    submenu.style.height = "0";

                    setTimeout(() => {
                        submenu.style.height = submenu_height + "px";
                        submenu.addEventListener(
                            "transitionend",
                            () => submenu.style.height = "auto",
                            {once: true}
                        );
                    }, 0);
                }
            }
        }

        /**
         * Called when menu link has been clicked.
         *
         * @param {Event} event
         */
        function on_menu_item_link_click(event) {
            if (screen.width >= breakpoints.xl) {
                return;
            }

            event.stopPropagation();
        }


        const menu_items_parents = menu.querySelectorAll("ul li.menu-item-has-children");
        const menu_items_links = menu.querySelectorAll("ul li a");

        for (const parent of menu_items_parents) {
            parent.addEventListener("click", on_menu_item_parent_click);
        }

        for (const link of menu_items_links) {
            link.addEventListener("click", on_menu_item_link_click);
        }
    })();


    (function () {
        /**
         * Called when first level item's child has been hovered.
         * @param {Event} event
         */
        function on_menu_first_level_child_mouseover(event) {
            if (screen.width < breakpoints.xl) {
                return;
            }

            const item = event.currentTarget.parentNode;
            const button = item.querySelector(":scope > .expand-button");

            item.classList.add("active");
            header.classList.add("filled");

            if (button) {
                button.ariaExpanded = "true";
            }
        }

        /**
         * Called when first level menu item has been unhovered.
         * @param {Event} event
         */
        function on_menu_first_level_item_mouseout(event) {
            if (screen.width < breakpoints.xl) {
                return;
            }

            const item = event.currentTarget;
            const button = item.querySelector(":scope > .expand-button");

            item.classList.remove("active");
            header.classList.remove("filled");

            if (button) {
                button.ariaExpanded = "false";
            }
        }

        /**
         * Called when expand button has been clicked.
         * @param {Event} event
         */
        function on_menu_first_level_item_button_click(event) {
            if (screen.width < breakpoints.xl) {
                return;
            }

            const button = event.currentTarget;
            const item = button.parentNode;

            if (item.classList.contains("active")) {
                item.classList.remove("active");
                header.classList.remove("filled");
                button.ariaExpanded = "false";
            } else {
                item.classList.add("active");
                header.classList.add("filled");
                button.ariaExpanded = "true";
            }
        }


        const menu_first_level_parents = menu.querySelectorAll(":scope > ul > li.menu-item-has-children");
        const menu_first_level_parents_links = menu.querySelectorAll(":scope > ul > li.menu-item-has-children > a");
        const menu_first_level_parents_buttons = menu.querySelectorAll(":scope > ul > li.menu-item-has-children > .expand-button");

        for (const link of menu_first_level_parents_links) {
            link.addEventListener("mouseover", on_menu_first_level_child_mouseover);
        }

        for (const item of menu_first_level_parents) {
            item.addEventListener("mouseleave", on_menu_first_level_item_mouseout);
        }

        for (const button of menu_first_level_parents_buttons) {
            button.addEventListener("mouseover", on_menu_first_level_child_mouseover);
            button.addEventListener("click", on_menu_first_level_item_button_click);
        }
    })();
})();

// Autosubmit forms.
(function () {
    const forms = document.querySelectorAll("form.autosubmit");

    for (const form of forms) {
        const inputs = form.querySelectorAll("input[type='checkbox'], input[type='radio']");

        for (const input of inputs) {
            input.addEventListener("change", function () {
                form.submit();
            });
        }
    }
})();
